module.exports = __webpack_public_path__ + "files/827f0342071508cc51e7a25248c5d3ea.png";